import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Header from '../layout/header'
import Footer from '../layout/footer'

const bg = require('../../images/banner/bnr4.jpg')

class Shop extends Component {


    render() {
        return (
            <>
                <Header/>
                <div class="page-content bg-white">
                    <div class="dlab-bnr-inr overlay-black-middle bg-pt" style={{ backgroundImage: "url(" + bg + ")" }}>
                        <div class="container">
                            <div class="dlab-bnr-inr-entry">
                                <h1 class="text-white">Compra de Equipo</h1>
                                <div class="breadcrumb-row">
                                    <ul class="list-inline">
                                        <li><Link to="/">Home</Link></li>
                                        <li>Compra de Equipo</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="section-full content-inner">
                        <div class="container">
                            <div class="row">
                                <div class="col-lg-3 col-md-4 col-sm-6">
                                    <div class="item-box m-b10">
                                        <div class="item-img">
                                            <img src={require("../../images/product/item1.jpg")} alt=""/>
                                            <div class="item-info-in">
                                                <ul>
                                                    <li><Link to="/shop-cart"><i class="ti-shopping-cart"></i></Link></li>
                                                    <li><Link to="#"><i class="ti-eye"></i></Link></li>
                                                    <li><Link to="#"><i class="ti-heart"></i></Link></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="item-info text-center text-black p-a10">
                                            <h6 class="item-title font-weight-500"><Link to="/shop-product-details">Arenador</Link></h6>
                                            <ul class="item-review">
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star-half-o"></i></li>
                                                <li><i class="fa fa-star-o"></i></li>
                                            </ul>
                                            <h4 class="item-price"><del>$2,032</del> <span class="text-primary">$1,192</span></h4>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-3 col-md-4 col-sm-6">
                                    <div class="item-box m-b10 item-style-1">
                                        <div class="item-img">
                                            <img src={require("../../images/product/item2.jpg")} alt=""/>
                                            <div class="item-info-in">
                                                <ul>
                                                    <li><Link to="/shop-cart"><i class="ti-shopping-cart"></i></Link></li>
                                                    <li><Link to="#"><i class="ti-eye"></i></Link></li>
                                                    <li><Link to="#"><i class="ti-heart"></i></Link></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="item-info text-center text-black p-a10">
                                            <h6 class="item-title font-weight-500"><Link to="/shop-product-details">Bombas de agua</Link></h6>
                                            <ul class="item-review">
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star-half-o"></i></li>
                                                <li><i class="fa fa-star-o"></i></li>
                                            </ul>
                                            <h4 class="item-price"><del>$20,32</del> <span class="text-primary">$19,92</span></h4>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-3 col-md-4 col-sm-6">
                                    <div class="item-box m-b10">
                                        <div class="item-img">
                                            <img src={require("../../images/product/item3.jpg")} alt=""/>
                                            <div class="item-info-in">
                                                <ul>
                                                    <li><Link to="/shop-cart"><i class="ti-shopping-cart"></i></Link></li>
                                                    <li><Link to="#"><i class="ti-eye"></i></Link></li>
                                                    <li><Link to="#"><i class="ti-heart"></i></Link></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="item-info text-center text-black p-a10">
                                            <h6 class="item-title font-weight-500"><Link to="/shop-product-details">Equipo ejemplo</Link></h6>
                                            <ul class="item-review">
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star-half-o"></i></li>
                                                <li><i class="fa fa-star-o"></i></li>
                                            </ul>
                                            <h4 class="item-price"><del>$232</del> <span class="text-primary">$192</span></h4>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-3 col-md-4 col-sm-6">
                                    <div class="item-box m-b10">
                                        <div class="item-img">
                                            <img src={require("../../images/product/item4.jpg")} alt=""/>
                                            <div class="item-info-in">
                                                <ul>
                                                    <li><Link to="/shop-cart"><i class="ti-shopping-cart"></i></Link></li>
                                                    <li><Link to="#"><i class="ti-eye"></i></Link></li>
                                                    <li><Link to="#"><i class="ti-heart"></i></Link></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="item-info text-center text-black p-a10">
                                            <h6 class="item-title font-weight-500"><Link to="/shop-product-details">Light Blue Denim Dress</Link></h6>
                                            <ul class="item-review">
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star-half-o"></i></li>
                                                <li><i class="fa fa-star-o"></i></li>
                                            </ul>
                                            <h4 class="item-price"><del>$232</del> <span class="text-primary">$192</span></h4>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-3 col-md-4 col-sm-6">
                                    <div class="item-box m-b10">
                                        <div class="item-img">
                                            <img src={require("../../images/product/item5.jpg")} alt=""/>
                                            <div class="item-info-in">
                                                <ul>
                                                    <li><Link to="/shop-cart"><i class="ti-shopping-cart"></i></Link></li>
                                                    <li><Link to="#"><i class="ti-eye"></i></Link></li>
                                                    <li><Link to="#"><i class="ti-heart"></i></Link></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="item-info text-center text-black p-a10">
                                            <h6 class="item-title font-weight-500"><Link to="/shop-product-details">Green Trousers</Link></h6>
                                            <ul class="item-review">
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star-half-o"></i></li>
                                                <li><i class="fa fa-star-o"></i></li>
                                            </ul>
                                            <h4 class="item-price"><del>$232</del> <span class="text-primary">$192</span></h4>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-3 col-md-4 col-sm-6">
                                    <div class="item-box m-b10 item-style-1">
                                        <div class="item-img">
                                            <img src={require("../../images/product/item6.jpg")} alt=""/>
                                            <div class="item-info-in">
                                                <ul>
                                                    <li><Link to="/shop-cart"><i class="ti-shopping-cart"></i></Link></li>
                                                    <li><Link to="#"><i class="ti-eye"></i></Link></li>
                                                    <li><Link to="#"><i class="ti-heart"></i></Link></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="item-info text-center text-black p-a10">
                                            <h6 class="item-title font-weight-500"><Link to="/shop-product-details">Unisex Sunglasses</Link></h6>
                                            <ul class="item-review">
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star-half-o"></i></li>
                                                <li><i class="fa fa-star-o"></i></li>
                                            </ul>
                                            <h4 class="item-price"><del>$232</del> <span class="text-primary">$192</span></h4>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-3 col-md-4 col-sm-6">
                                    <div class="item-box m-b10">
                                        <div class="item-img">
                                            <img src={require("../../images/product/item7.jpg")} alt=""/>
                                            <div class="item-info-in">
                                                <ul>
                                                    <li><Link to="/shop-cart"><i class="ti-shopping-cart"></i></Link></li>
                                                    <li><Link to="#"><i class="ti-eye"></i></Link></li>
                                                    <li><Link to="#"><i class="ti-heart"></i></Link></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="item-info text-center text-black p-a10">
                                            <h6 class="item-title font-weight-500"><Link to="/shop-product-details">Blue Round-Neck Tshirt</Link></h6>
                                            <ul class="item-review">
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star-half-o"></i></li>
                                                <li><i class="fa fa-star-o"></i></li>
                                            </ul>
                                            <h4 class="item-price"><del>$232</del> <span class="text-primary">$192</span></h4>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-3 col-md-4 col-sm-6">
                                    <div class="item-box m-b10">
                                        <div class="item-img">
                                            <img src={require("../../images/product/item8.jpg")} alt=""/>
                                            <div class="item-info-in">
                                                <ul>
                                                    <li><Link to="/shop-cart"><i class="ti-shopping-cart"></i></Link></li>
                                                    <li><Link to="#"><i class="ti-eye"></i></Link></li>
                                                    <li><Link to="#"><i class="ti-heart"></i></Link></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="item-info text-center text-black p-a10">
                                            <h6 class="item-title font-weight-500"><Link to="/shop-product-details">Men Grey Casual Shoes</Link></h6>
                                            <ul class="item-review">
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star-half-o"></i></li>
                                                <li><i class="fa fa-star-o"></i></li>
                                            </ul>
                                            <h4 class="item-price"><del>$232</del> <span class="text-primary">$192</span></h4>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-3 col-md-4 col-sm-6">
                                    <div class="item-box m-b10">
                                        <div class="item-img">
                                            <img src={require("../../images/product/item9.jpg")} alt=""/>
                                            <div class="item-info-in">
                                                <ul>
                                                    <li><Link to="/shop-cart"><i class="ti-shopping-cart"></i></Link></li>
                                                    <li><Link to="#"><i class="ti-eye"></i></Link></li>
                                                    <li><Link to="#"><i class="ti-heart"></i></Link></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="item-info text-center text-black p-a10">
                                            <h6 class="item-title font-weight-500"><Link to="/shop-product-details">Checked Short Dress</Link></h6>
                                            <ul class="item-review">
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star-half-o"></i></li>
                                                <li><i class="fa fa-star-o"></i></li>
                                            </ul>
                                            <h4 class="item-price"><del>$232</del> <span class="text-primary">$192</span></h4>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-3 col-md-4 col-sm-6">
                                    <div class="item-box m-b10 item-style-1">
                                        <div class="item-img">
                                            <img src={require("../../images/product/item1.jpg")} alt=""/>
                                            <div class="item-info-in">
                                                <ul>
                                                    <li><Link to="/shop-cart"><i class="ti-shopping-cart"></i></Link></li>
                                                    <li><Link to="#"><i class="ti-eye"></i></Link></li>
                                                    <li><Link to="#"><i class="ti-heart"></i></Link></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="item-info text-center text-black p-a10">
                                            <h6 class="item-title font-weight-500"><Link to="/shop-product-details">Slim Fit Chinos</Link></h6>
                                            <ul class="item-review">
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star-half-o"></i></li>
                                                <li><i class="fa fa-star-o"></i></li>
                                            </ul>
                                            <h4 class="item-price"><del>$232</del> <span class="text-primary">$192</span></h4>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-3 col-md-4 col-sm-6">
                                    <div class="item-box m-b10">
                                        <div class="item-img">
                                            <img src={require("../../images/product/item2.jpg")} alt=""/>
                                            <div class="item-info-in">
                                                <ul>
                                                    <li><Link to="/shop-cart"><i class="ti-shopping-cart"></i></Link></li>
                                                    <li><Link to="#"><i class="ti-eye"></i></Link></li>
                                                    <li><Link to="#"><i class="ti-heart"></i></Link></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="item-info text-center text-black p-a10">
                                            <h6 class="item-title font-weight-500"><Link to="/shop-product-details">Dark Brown Boots</Link></h6>
                                            <ul class="item-review">
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star-half-o"></i></li>
                                                <li><i class="fa fa-star-o"></i></li>
                                            </ul>
                                            <h4 class="item-price"><del>$232</del> <span class="text-primary">$192</span></h4>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-3 col-md-4 col-sm-6">
                                    <div class="item-box m-b10">
                                        <div class="item-img">
                                            <img src={require("../../images/product/item3.jpg")} alt=""/>
                                            <div class="item-info-in">
                                                <ul>
                                                    <li><Link to="/shop-cart"><i class="ti-shopping-cart"></i></Link></li>
                                                    <li><Link to="#"><i class="ti-eye"></i></Link></li>
                                                    <li><Link to="#"><i class="ti-heart"></i></Link></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="item-info text-center text-black p-a10">
                                            <h6 class="item-title font-weight-500"><Link to="/shop-product-details">Light Blue Denim Dress</Link></h6>
                                            <ul class="item-review">
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star-half-o"></i></li>
                                                <li><i class="fa fa-star-o"></i></li>
                                            </ul>
                                            <h4 class="item-price"><del>$232</del> <span class="text-primary">$192</span></h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="section-full p-t50 p-b20 bg-primary text-white">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-4 col-lg-4">
                                    <div class="icon-bx-wraper left shop-service-info m-b30">
                                        <div class="icon-md text-black radius">
                                            <Link to="#" class="icon-cell text-white"><i class="fa fa-gift"></i></Link>
                                        </div>
                                        <div class="icon-content">
                                            <h5 class="dlab-tilte">Envío gratuito en compras $20k+</h5>
                                            <p>Genera una orden superior a $20,000 y obten un envío gratis.</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 col-lg-4">
                                    <div class="icon-bx-wraper left shop-service-info m-b30">
                                        <div class="icon-md text-black radius"> 
                                            <Link to="#" class="icon-cell text-white"><i class="fa fa-plane"></i></Link> 
                                        </div>
                                        <div class="icon-content">
                                            <h5 class="dlab-tilte">Envíos nacionales</h5>
                                            <p>Envíos a toda la república a través de DHL, Fedex, etc.</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 col-lg-4">
                                    <div class="icon-bx-wraper left shop-service-info m-b30">
                                        <div class="icon-md text-black radius"> 
                                            <Link to="#" class="icon-cell text-white"><i class="fa fa-history"></i></Link> 
                                        </div>
                                        <div class="icon-content">
                                            <h5 class="dlab-tilte">Garantía directa con proveedores</h5>
                                            <p>Contamos con garantías directas con productores y distribuidores</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>                
                <Footer hideContactInfo />                
            </>
        )
    }
}
export default Shop;